<template>
    <div
        class="multi-select"
        @mouseenter="mouseenter"
        @mouseleave="mouseleave"
    >
        <div
            class="basis"
            @click="isOpen = !isOpen"
        >
            <header
                v-if="innerModel.length"
            >{{ label }}</header>

            <main>
                <div class="text">
                    <template
                        v-if="!innerModel.length"
                    >{{ label }}</template>
                    <template v-else>{{ enumerate }}</template>
                </div>

                <div
                    class="button"
                    :class="{ flipped: isOpen }"
                ></div>
            </main>
        </div>

        <div
            class="options"
            v-if="isOpen"
        >
            <div
                class="option"
                v-for="item in items"
                :key="item.id"
            >
                <label><input
                    type="checkbox"
                    :value="item.id"
                    v-model="innerModel"
                >{{ item.title }}</label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MultiSelect',
    data: () => ({
        isOpen: false,
        timerToClose: null,
        innerModel: [],
    }),
    props: {
        label: String,
        items: Array,
        outerModel: Array,
    },
    computed: {
        enumerate() {
            const results = [];

            const eachKey = k => results
                .push(this.items.find(item => item.id == k).title);

            this.innerModel.forEach(eachKey);

            return results.join(', ');
        },
    },
    methods: {
        mouseenter() {
            clearTimeout(this.timerToClose);
        },
        mouseleave() {
            const handler = () => this.isOpen = false;

            this.timerToClose = setTimeout(handler, 1e3);
        },
    },
    model: {
        prop: 'outerModel',
        event: 'change',
    },
    watch: {
        innerModel(value) {
            this.$emit('change', value);
        },
        outerModel(value) {
            this.innerModel = value;
        },
    },
    mounted() {
        this.innerModel = this.outerModel;
    },
};
</script>

<style lang="scss" scoped>
    @import '../../../styles/mrem';

    .multi-select {
        display: flex;
        flex-direction: column;

        * {
            font-size: .8rem;
            user-select: none;
        }

        position: relative;
    }

    .basis {
        height: 2rem;
        position: relative;
        border: 1px solid #b9b9b9;
        padding: .5rem;
        border-radius: .2rem;

        header {
            padding: 0 .3rem;
            position: absolute;
            font-size: .6rem;
            top: -.5rem;
            left: 0.2rem;
            background-color: #fff;
        }

        main {
            display: flex;
            align-items: center;
            height: 100%;

            .text {
                flex-grow: 1;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }

            .button {
                margin-left: .5rem;
                width: 1rem;
                height: 1rem;
                flex: none;
                background: center no-repeat
                    url(../../../assets/images/UI/drop.svg);

                &.flipped {
                    transform: rotate(180deg);
                }
            }
        }
    }

    .options {
        position: absolute;
        top: 1.5rem;
        z-index: 5;
        left: 0;
        border: 1px solid #b9b9b9;
        border-radius: 0 0 .2rem .2rem;
        border-top: none;
        background-color: #fff;
        width: 100%;
        padding: .2rem .5rem .5rem;
        overflow: hidden;

        .option {
            margin-top: .2rem;

            input {
                margin-right: .4rem;
            }

            label {
                white-space: nowrap;
            }
        }
    }
    @import "../../../styles/variables";

    @media (max-width: $vm) {
      .basis {
        height: mrem(48);
        padding: mrem(13) mrem(14);
        border: solid mrem(1) #b9b9b9;
        border-radius: mrem(4);
        font-size: mrem(16);
        line-height: mrem(22);
        color: #98A0A9;

        header {
          top: mrem(-13);
          left: mrem(10);
          font-size: mrem(12);
        }

        main .button {
          width: mrem(16);
          height: mrem(16);
        }
      }

      .multi-select {
        * {
            font-size: mrem(16);
        }
      }

      .options {
        top: mrem(40);
        border: solid mrem(1) #b9b9b9;
        border-top: none;
        border-bottom-right-radius: mrem(4);
        border-bottom-left-radius: mrem(4);

        .option {
          padding: mrem(10) mrem(14);

          input {
            width: mrem(15);
            height: mrem(15);
            margin: 0 mrem(10) 0 0;
          }
        }
      }
    }
</style>
